export interface PaymentMethodOption {
  id: string | number;
  label: string;
}

type Translate = (key: string) => string;

const PAYMENT_METHOD_LABEL_KEYS: Record<string, string> = {
  CREDIT: "fueling.paymentMethod.credit",
  CREDITO: "fueling.paymentMethod.credit",
  DEBIT: "fueling.paymentMethod.debit",
  DEBITO: "fueling.paymentMethod.debit",
  CASH: "fueling.paymentMethod.cash",
  DINHEIRO: "fueling.paymentMethod.cash",
  PIX: "fueling.paymentMethod.pix",
};

const normalize = (value: string): string =>
  value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toUpperCase();

export const resolvePaymentMethodLabel = (
  value: string | number | null | undefined,
  t: Translate,
  options: PaymentMethodOption[] = []
): string | null => {
  if (value == null) return null;

  const raw = String(value).trim();
  if (!raw) return null;

  const labelKey = PAYMENT_METHOD_LABEL_KEYS[normalize(raw)];
  if (labelKey) return t(labelKey);

  const option = options.find((item) => String(item.id) === raw);
  return option?.label ?? raw;
};
